export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const prefillEnquiry = (detail) => {
  window.dispatchEvent(new CustomEvent("prefill-enquiry", { detail }));
  scrollToHash("#enquiry");
};
